@import 'styles/mixins';
@import 'styles/variables';

.container {
  :global .ant-modal-content {
    border-radius: 8px;
    @include shadow-3;
  }

  :global .ant-modal-body {
    padding: 0;
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
}

.headerText {
  @include header-md;
  margin-bottom: 0;
}

.closeButton {
  display: flex;
  align-items: center;

  & svg {
    fill: $almanac-black;
  }
}

.body {
  @include body-md-text;
  color: $gray-90;
  max-width: 560px;
  padding: 24px;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px 24px;

  button {
    margin-left: 16px;

    &.removeAndDeleteBtn {
      color: $almanac-black;
    }
  }
}

.branches {
  margin: 24px 0;
  max-height: 300px;
  overflow: auto;

  .branchRow {
    @include ui-sm-text;
    color: $almanac-black;
    padding: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 8px 0;

    background: $white;
    border: 1px solid $gray-20;
    box-shadow: 0px 1px 1px rgba(19, 21, 26, 0.06);
    border-radius: 4px;

    svg {
      fill: $gray-40;
      margin-right: 6px;
    }
  }
}
